import React from "react";
import convertId from "../../utilities/convert-id";
import { graphql } from "gatsby";
import Content from "../utilities/content";
import CmsImage from "../utilities/cms-image";
import CmsLink from "../utilities/cms-link";

const ContentTwoColumns = ({ data }) => {
  return (
    <section
      id={convertId(data.name)}
      className={`section clipped-small-top bg-light section-column-two ${
        data.extraSpacingBottom ? "extra-spacing-bottom" : ""
      } ${data.removeBackgroundClipFromBottom ? "remove-btm-clip" : ""} ${
        data.backgroundColor === "white" ? "bg-white" : "bg-gray"
      }`}
      style={{
        ...(data.textColor === "white" && { color: data.textColor }),
      }}
    >
      {data.backgroundImage && (
        <CmsImage className="section-img" image={data.backgroundImage} />
      )}
      <div className="container sz">
        <div className="row">
          {data.contentRepeater &&
            data.contentRepeater.map((item, i) => (
              <div key={i} className="col-lg-6 mb-5 mb-lg-0 position-relative">
                <Content
                  className={`content-two-cols position-relative ${
                    item.imageCroppedCorner ? "clip-img" : ""
                  } ${item.textColor === "white" ? "text-white" : ""}`}
                >
                  {item.content}
                </Content>
                {item.button && (
                  <CmsLink
                    className={`btn ${
                      item.whiteButton ? "btn-white" : "btn-primary"
                    } mt-5 btn-arrow`}
                    link={item.button}
                    whiteBtn={item.whiteButton}
                  />
                )}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment ContentTwoColumns on WpPage_Sections_Sections_ContentTwoColumns {
    fieldGroupName
    name
    removeBackgroundClipFromBottom
    backgroundColor
    backgroundImage {
      altText
      localFile {
        childImageSharp {
          gatsbyImageData
        }
        extension
        publicURL
      }
    }
    extraSpacingBottom
    contentRepeater {
      fieldGroupName
      content
      textColor
      addColumnBackground
      backgroundImage {
        altText
        localFile {
          childImageSharp {
            gatsbyImageData
          }
          extension
          publicURL
        }
      }
      backgroundColor
      imageCroppedCorner
      button {
        target
        title
        url
      }
      whiteButton
    }
  }
`;

export default ContentTwoColumns;
